module.exports = __webpack_public_path__ + "static/media/Samsung-Galaxy-Note-4.c237c348.jpg";